"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormActions = exports.Form = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../../utility/distillUtilityClasses"));
exports.Form = function (props) {
    var inline = props.inline, fill = props.fill, grid = props.grid, _a = props.component, Component = _a === void 0 ? "div" : _a, className = props.className, utilityAndDivProps = __rest(props, ["inline", "fill", "grid", "component", "className"]);
    var _b = distillUtilityClasses_1.default(utilityAndDivProps), utilityClasses = _b[0], divProps = _b[1];
    var classes = ["c-form"];
    if (inline) {
        classes.push("+inline");
    }
    if (fill) {
        classes.push("+fill");
    }
    if (grid) {
        classes.push("+grid");
    }
    classes.push.apply(classes, __spreadArrays(utilityClasses, [className]));
    return react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, divProps));
};
exports.Form.displayName = "Form";
exports.FormActions = function (props) {
    var _a = props.component, Component = _a === void 0 ? "div" : _a, className = props.className, utilityAndDivProps = __rest(props, ["component", "className"]);
    var _b = distillUtilityClasses_1.default(utilityAndDivProps), utilityClasses = _b[0], divProps = _b[1];
    var classes = ["c-form__actions"];
    classes.push.apply(classes, __spreadArrays(utilityClasses, [className]));
    return react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, divProps));
};
exports.FormActions.displayName = "FormActions";
//# sourceMappingURL=Form.js.map